import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { colors } from '../../utils/styles';
import { urls } from '../../utils/urls';

import { mapStateToProps } from '../../utils/mapper';

import ExtenralLink from '../../components/external_link';

interface FooterProps {
  children?: any,
  row?: boolean,
  onClick?: () => void;
}

const styles = (multiplier) => ({
  copyright: RX.Styles.createTextStyle({
    fontSize: 12 * multiplier,
  }),
  footer: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: colors.background,
    justifyContent: 'center',
    padding: 16 * multiplier,
  }),
  links: RX.Styles.createViewStyle({
    flexDirection: 'row',
    marginBottom: 8 * multiplier
  }),
  pipe: RX.Styles.createTextStyle({
    fontSize: 14 * multiplier,
    // height: 40,
    marginBottom: 28 * multiplier,
    paddingLeft: 14 * multiplier,
    paddingRight: 14 * multiplier,
  }),
  wrapper: RX.Styles.createViewStyle({
    alignItems: 'center'
  })
});

interface FooterProps {
  window: { multiplier: number}
};

class Footer extends RX.Component<FooterProps> {

  public render() {
    const date = new Date();

    const { window: { multiplier }} =  this.props;

    return (
      <RX.View style={styles(multiplier).footer}>
        <RX.View style={styles(multiplier).wrapper}>
          <RX.View style={styles(multiplier).links}>
            <ExtenralLink
              small
              text='Privacy Policy'
              destination={urls.privacyPolicy}
              locText='Lancaster General Health Privacy Policy'
            />
            <RX.Text style={styles(multiplier).pipe}>|</RX.Text>
            <ExtenralLink
              small
              text='Lancaster General Health'
              destination={urls.home}
              locText='Lancaster General Health'
            />
          </RX.View>
          <RX.Text
            style={styles(multiplier).copyright}
          >
            &copy;{` ${date.getFullYear()} Lancaster General Health`}
          </RX.Text>
        </RX.View>
      </RX.View>
    );
  }
}

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/footer/index.tsx